var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pb-3", attrs: { role: "main", id: "instructions" } },
    [
      _c("h1", [_vm._v(_vm._s(_vm.$t(_vm.title)))]),
      _vm._v(" "),
      _c("div", {
        domProps: {
          innerHTML: _vm._s(
            _vm.$t(
              "InvestmentReport.Instructions.TechnicalInstructions" +
                _vm.InvestmentReportType[_vm.reportType].toString()
            )
          )
        }
      }),
      _vm._v(" "),
      _c("basic-info-instructions"),
      _vm._v(" "),
      _c("h2", [_vm._v(_vm._s(_vm.$t("InvestmentReport.Menu.Finances")))]),
      _vm._v(" "),
      _vm.isPremises ? _c("premises-finances-instructions") : _vm._e(),
      _vm._v(" "),
      _vm.isICT ? _c("ict-finances-instructions") : _vm._e(),
      _vm._v(" "),
      _vm.isSupportApartments
        ? _c("support-apartments-finances-instructions")
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }